// @ts-nocheck
import React, { useEffect } from 'react';
import NetworkApi from '../api/NetworkApi';
import paths from '../api/paths';
import { get, isEmpty } from 'lodash';
import { parseQueryParams, redirectTo } from '../Utils/utils';
import { STORAGE_KEYS } from '../Utils/constants';
import { getItem, setItem } from '../Utils/Storage';
import useAsync from './useAsync';
import { SignInCodeResponse } from '../modals/authmodals';
import { PILET_NAMES } from '../configs/config';

const defaultHeaders = {
  'content-type': 'application/json',
  accept: 'application/json',
  authorization:
    'Basic c2NyYXRjaGNhcmQtZmludHJhbnMtc2VydmljZTpzS3EzUFE5Nk1FTHhMM3Y3dm5hMA=='
};

const handleProfileInfoResponse = (profileResponse) => {
  const formData: any = get(
    profileResponse,
    'data.payload.formDefinition.formData',
    {}
  );

  const { bankName, accountNumber } = formData;
  if (!accountNumber && !bankName) {
    return {
      profileFilled: false
    };
  } else {
    setItem(STORAGE_KEYS.PROFILE, formData);

    const paymentInfo = getItem(STORAGE_KEYS.PAYMENTS_CONFIG);
    setItem(STORAGE_KEYS.PAYMENTS_CONFIG, {
      ...paymentInfo,
      contactNumber: formData.mobileNumber,
      name: formData.businessName
    });

    return {
      profileFilled: true
    };
  }
};

const useLogin = ({ setAuthData }) => {
  const [queryParams, setQueryParams] = React.useState({});
  const userInfoAsync = useAsync(null, null);
  const profileInfoAsync = useAsync(handleProfileInfoResponse, null);
  const signincodeAsync = useAsync((res: SignInCodeResponse) => {
    setItem(STORAGE_KEYS.ACCESS_TOKEN, res.data);
    const paymentInfo = getItem(STORAGE_KEYS.PAYMENTS_CONFIG);
    const obj = {
      ...res.data,
      token: res.data.access_token,
      realms: [
        {
          userRealmId: 457,
          asgardUserId: res.data.userId,
          realmIdentifier: res.data.realmId,
          systemUserId: res.data.userId
        }
      ],
      realmIdentifier: res.data.realmId,
      env: 'agnet'
    };
    setItem(STORAGE_KEYS.AUTH_CONFIG, obj);
    setItem(STORAGE_KEYS.PAYMENTS_CONFIG, {
      ...obj,
      ...paymentInfo
    });
    setItem(STORAGE_KEYS.DASHBOARD_DATA, {
      balance: 0
    });
  }, null);
  const vanAccountAsync = useAsync(null, null);

  const getUserInfo = (userId) => {
    const auth = getItem(STORAGE_KEYS.ACCESS_TOKEN);

    userInfoAsync.run(NetworkApi.get, paths.userInfo(userId), {
      ...defaultHeaders,
      authorization: `${auth.token_type} ${auth.access_token}`
    });
  };

  useEffect(() => {
    if (userInfoAsync?.state?.isSuccess) {
      const paymentConfig = getItem(STORAGE_KEYS.PAYMENTS_CONFIG);
      const name = get(userInfoAsync, 'state.data[0].User.name', '');
      const obj = {
        name
      };
      setItem(STORAGE_KEYS.PAYMENTS_CONFIG, { ...obj, ...paymentConfig });
    }
  }, [userInfoAsync?.state?.isSuccess]);

  const getProfileInformation = (userId, realmId) => {
    try {
      const parsedAuthData = getItem(STORAGE_KEYS.AUTH_CONFIG);

      const postData = {
        requestId: userId,
        userId: userId,
        workflowName: 'UserProfileDetailsDisplay_Workflow',
        dataMap: { input: {} }
      };
      profileInfoAsync.run(
        NetworkApi.post,
        paths.profile(userId, realmId),
        postData,
        {
          ...defaultHeaders,
          'auth-type': 'token',

          authorization: `Bearer ${
            parsedAuthData.token || parsedAuthData.access_token
          }`
          // authorization: `Bearer eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJ7XG4gIFwicmVhbG1JZFwiIDogXCJkZDE4MGJjYS00NjVhLTQ3MGEtYWJlNC05ZDVhMTVkZWQ1NTFcIixcbiAgXCJ1c2VyTmFtZVwiIDogXCJLb3BwYXJ0aGlOQzE1MjM0XCIsXG4gIFwicm9sZXNcIiA6IFwiVFJBREVSXCIsXG4gIFwicmVhbG1VbmlxdWVJZGVudGlmaWVyXCIgOiBudWxsLFxuICBcInVzZXJJZFwiIDogMTE5Nzc5MSxcbiAgXCJzeXN0ZW1Vc2VySWRcIiA6IG51bGwsXG4gIFwiY3VycmVudFJlYWxtXCIgOiBudWxsXG59IiwiYXVkIjoiTmluamFjYXJ0RW1wbG95ZWUiLCJpc3MiOiJOaW5qYWNhcnQiLCJpYXQiOjE2NTYzOTY3MTMsImV4cCI6MTY1NzY5MjcxM30.RzH8Iw-XO8bwO65wIg-lGxZ7x0OqzYdQB2T8qeia8Zhex6N2o40X3U6wYKMIFrR2jZySvIFBOX4CdeM-v_OAyXxPcY-2wsS3gWJ9WdvQq36v4qnmOsTbTrgt02ws77yhRAvuwBvmb_G7VA8-ONuuTEkGLMb-3hzOYbIoh2QhWtB9LiyixFsMrAE_KBcyE8ZBk2DGTgGE9pNG-t9uaaGe1vZYcec3nvHCHijZbjx8-BpcmG__Z6vyzGY4N5VcNB15N3CypuWmNQx3_nr-uiMh3hchxiiy9Q3yHqOYoHXPCU0BDeMX-GxfXmZU6_kjeuRORK9yLjT7mV9fk8-RABEqsw`
        }
      );
    } catch (e) {
      console.warn('profile info api failed', e.message);
    }
  };

  useEffect(() => {
    if (signincodeAsync.state.isSuccess) {
      const userId = get(queryParams, 'userId', '');
      getUserInfo(userId);
    }
  }, [signincodeAsync.state]);

  const getAuthToken = (queryParams) => {
    const {
      code,
      realmId,
      userId,
      orderId = '',
      amount = '',
      contactNumber = '',
      receiver = '',
      callbackUrl,
      showCreditCardAndCash = false
    } = queryParams;
    setItem(STORAGE_KEYS.PAYMENTS_CONFIG, {
      orderId: orderId,
      amount: amount,
      contactNumber: contactNumber,
      callbackUrl,
      receiver,
      showCreditCardAndCash,
      bnplCallBakcRedirectURL: `${window.location.origin}/ninjapay`
    });
    const body = { code, realmId, userId };

    signincodeAsync.run(
      NetworkApi.post,
      paths.signInCode(),
      body,
      defaultHeaders
    );
  };

  useEffect(() => {
    const parsedInfo = parseQueryParams(get(window, 'location.search', {}));
    const code = get(parsedInfo, 'code', undefined);
    const appName = window.location.pathname?.replace('/', '');
    if (parsedInfo?.code && parsedInfo?.invoiceid && appName === PILET_NAMES.NINJAPAY) {
      redirectTo(`/ninjapay${window.location.search}`);
      return;
    } else if (parsedInfo?.code && parsedInfo?.phonenumber && appName === PILET_NAMES.REGISTRATION) {
      redirectTo(`/registration${window.location.search}`);
      return;
    } else if (parsedInfo?.code && appName === PILET_NAMES.EKYC) {
      redirectTo(`/kyc-select${window.location.search}`);
      return;
    }
    setQueryParams(parsedInfo);
    if (parsedInfo)
      if (parsedInfo?.code) {
        window.localStorage.clear();
      }
    if (
      window.location.pathname === '/' &&
      isEmpty(localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)) &&
      code
    ) {
      getAuthToken(parsedInfo);
    }
  }, []);

  const getTraderInfo = async ({
    userId,
    token,
    token_type = 'Bearer',
    realmOwnerData
  }: any) => {
    const decodedRealmsString = decodeURIComponent(realmOwnerData);
    const decodedToken = decodeURIComponent(token);
    NetworkApi.post(
      paths.traderHome(userId),
      {},
      {
        ...defaultHeaders,
        // realmId: realmIdentifier,
        'auth-type': 'token',
        authorization: `${token_type} ${decodedToken}`
      }
    ).then((res) => {
      const data = get(res, 'data', {});
      setAuthData({
        dashboardData: data,
        authData: {
          userId,
          token: decodedToken,
          token_type,
          realms: [JSON.parse(decodedRealmsString)]
        }
      });
    });
  };

  return {
    getTraderInfo,
    signInCodeState: signincodeAsync.state,
    profileInfo: profileInfoAsync.state,
    getProfileInformation,
    queryParams,
    isLoading:
      userInfoAsync.state.isLoading ||
      profileInfoAsync.state.isLoading ||
      signincodeAsync.state.isLoading
  };
};

export default useLogin;
